import { useCallback, useRef } from 'react';
import type { IMdEdit } from './IMdEdit';
import { mdInsert, mdPrefixLines, mdWrap } from './mdEdit';

/**
 * Правки поля статті з панелі форматування (прототип kbTools): обгортання виділення, префікс рядків, вставка блоку — нове значення
 * віддається onChange, а курсор і виділення відновлюються після оновлення поля.
 */
export function useMdEditor(value: string, onChange: (v: string) => void) {
  const area = useRef<HTMLTextAreaElement>(null);
  const apply = useCallback((edit: (body: string, s0: number, s1: number) => IMdEdit) => {
    const ta = area.current;
    const s0 = ta ? ta.selectionStart : value.length;
    const s1 = ta ? ta.selectionEnd : value.length;
    const r = edit(value, s0, s1);
    onChange(r.text);
    setTimeout(() => { if (ta) { ta.focus(); ta.setSelectionRange(r.start, r.end); } }, 0);
  }, [value, onChange]);
  const selected = () => { const ta = area.current; return ta ? value.slice(ta.selectionStart, ta.selectionEnd) : ''; };
  return {
    area,
    selected,
    wrap: (a: string, b: string, placeholder: string) => apply((v, s0, s1) => mdWrap(v, s0, s1, a, b, placeholder)),
    line: (prefix: string) => apply((v, s0, s1) => mdPrefixLines(v, s0, s1, prefix)),
    insert: (fragment: string, block = false) => apply((v, s0, s1) => mdInsert(v, s0, s1, fragment, block)),
  };
}
